import React from "react";
import { CollegesData, Course } from "../../../util/types";
import CollegeCard from "./CollegeCard";
import Advertisment from "./Advertisment";
import TopCollegesUniversities from "../../college-predictor-details/components/TopCollegesUniversities";

interface PredictorResultCardProps {
  data: CollegesData;
  userRank?: string;
  allCourses?: any[];
}

const PredictorResultCard: React.FC<PredictorResultCardProps> = ({
  data,
  userRank,
  allCourses = [],
}) => {
  if (!data.colleges || data.colleges.length === 0) return null;

  const firstCollege = data.colleges[0];
  const restColleges = data.colleges.slice(1);

  return (
    <div className="flex flex-col gap-4">
      <CollegeCard
        key={firstCollege.collegeId}
        college={{ ...firstCollege, courseVo: firstCollege.courseVo }}
        userRank={userRank}
        allCourses={firstCollege.allCourses}
      />

      <TopCollegesUniversities />

      {restColleges.map((college, index) => (
        <React.Fragment key={college.collegeId}>
          <CollegeCard
            college={{ ...college, courseVo: college.courseVo }}
            userRank={userRank}
            allCourses={college.allCourses}
          />
          {(index + 1) % 1 === 0 && <Advertisment />}
        </React.Fragment>
      ))}
    </div>
  );
};

export default PredictorResultCard;
